import { atom } from "recoil";
import { OrderUmrahModel } from "../Models/orderUmrahModel";
export const SaleUmrahAtom = atom({
  key: "SaleUmrahAtom", // unique ID (with respect to other atoms/selectors)
  default: new OrderUmrahModel(), // default value (aka initial value)
});
